/* eslint-disable react-hooks/exhaustive-deps */

import React, {cloneElement, useCallback, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import {
    DELETE_CONTACT_ACCOUNT_POSITION,
    GET_CONTACT_ACCOUNT_POSITIONS
} from "../../database/queries/contactAccountPositionQueries";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../../constants/tableIcons";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import PageBar from "../Common/PageBar";
import {Route, Switch, useHistory, useRouteMatch} from "react-router-dom";
import {GET_ACCOUNTS_FIND_SIMILAR_NAMES} from "../../database/queries/accountQueries";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Moment from "react-moment";
import CalendarStrings from "../../constants/calendarStrings";
import usePersistentStore from "../../persistentStore";
import {tellParentContentHeight, tellParentMessage} from "../../utils/utils";
import ReactResizeDetector from 'react-resize-detector';
import moment from "moment";

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    accountList: {
        maxHeight: 370,
    }
}));

const PopupContactAccountPositionList = props => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [globalPersistentState] = usePersistentStore();
    const [contactAccountPositions, setContactAccountPositions] = useState();
    const [accountPossibleDupes, setAccountPossibleDupes] = useState();
    const [globalLayoutState] = useLayoutStore();
    let {url} = useRouteMatch();
    const history = useHistory();

    let columns = [
        {title: 'Name', field: 'account.accountName', width: '35%'},
        {title: 'Title', field: 'title', width: '35%'},
        {
            title: 'Start Date',
            render: r => <Moment calendar={CalendarStrings}>{r.startDate}</Moment>,
            width: '15%',
        },
        {
            title: 'End Date',
            render: r => {
                if (moment().isBefore(r.endDate)) {
                    return <span>Present</span>
                } else {
                    return <Moment calendar={CalendarStrings}>{r.endDate}</Moment>
                }
            },
            width: '15%',
        },
    ];

    const {data: getAccountsFindSimilarNameData} = useQuery(GET_ACCOUNTS_FIND_SIMILAR_NAMES, {
        skip: !globalPersistentState.popupQueryObj || !globalPersistentState.popupQueryObj.selectionText || globalPersistentState.popupQueryObj.selectionText.length === 0,
        variables: {name: globalPersistentState.popupQueryObj ? globalPersistentState.popupQueryObj.selectionText : ''},
    });

    useEffect(() => {
        if (getAccountsFindSimilarNameData && getAccountsFindSimilarNameData.accountsFindSimilarName && getAccountsFindSimilarNameData.accountsFindSimilarName.length > 0) {
            setAccountPossibleDupes(getAccountsFindSimilarNameData.accountsFindSimilarName);
        }
    }, [getAccountsFindSimilarNameData]);

    const {loading: getContactAccountPositionsLoading, error: getContactAccountPositionsError, data: getContactAccountPositionsData, refetch: getContactAccountPositionsRefetch} = useQuery(GET_CONTACT_ACCOUNT_POSITIONS, {
        skip: !props.editId || props.editId === 'new',
        variables: {
            contactId: props.editId,
            searchStr: searchStr,
            orderList: ['startDate DESC']
        },
    });

    const [deleteContactAccountPosition, {error: deleteContactAccountPositionError}] = useMutation(DELETE_CONTACT_ACCOUNT_POSITION);

    const handleSearch = (s) => {
        setSearchStr(s);
        getContactAccountPositionsRefetch();
    };

    const handleRefresh = () => {
        getContactAccountPositionsRefetch();
    };

    const handleDelete = () => {
        deleteContactAccountPosition({
            variables: {deleteContactAccountPositionId: selectedObj.contactAccountPositionId}
        }).then(deleteContactAccountPositionResult => {
            if (deleteContactAccountPositionResult.data.deleteContactAccountPosition.returnCode === 0) {
                notify('deleteContactAccountPosition', 'info', deleteContactAccountPositionResult.data.deleteContactAccountPosition.message, null, null, globalPersistentState.popupQueryObj);
            } else {
                notify('deleteContactAccountPosition', 'error', deleteContactAccountPositionResult.data.deleteContactAccountPosition.message, null, null, globalPersistentState.popupQueryObj);
            }
            getContactAccountPositionsRefetch();
        }).catch(e => {
            notify('deleteContactAccountPosition', 'error', e.message, null, null, globalPersistentState.popupQueryObj);
            getContactAccountPositionsRefetch();
        })
    };

    useEffect(() => {
        getContactAccountPositionsRefetch();
    }, [getContactAccountPositionsRefetch]);

    useEffect(() => {
        if (deleteContactAccountPositionError) notify('deleteContactAccountPositionError', 'error', deleteContactAccountPositionError.message, null, null, globalPersistentState.popupQueryObj);
        if (getContactAccountPositionsError) notify('getContactAccountPositionsError', 'error', getContactAccountPositionsError.message, null, null, globalPersistentState.popupQueryObj);
    }, [deleteContactAccountPositionError, getContactAccountPositionsError]);

    useEffect(() => {
        if (getContactAccountPositionsData && getContactAccountPositionsData.contactAccountPositions) {
            let myContactAccountPositions = [];
            getContactAccountPositionsData.contactAccountPositions.map(contactAccountPosition => {
                let myContactAccountPosition = {...contactAccountPosition};
                myContactAccountPositions.push(myContactAccountPosition);
                return myContactAccountPosition;
            });
            setSelectedRows([]);
            setSelectedObj({});
            setContactAccountPositions(myContactAccountPositions);
        }
    }, [getContactAccountPositionsData]);

    useEffect(() => {
        if (globalPersistentState.popupQueryObj.selectionText && globalPersistentState.popupQueryObj.selectionText.length > 0 && window.location.pathname.endsWith('/positions')) {
            const newLink = '/popup/contact/' + props.editId + '/positions/new/new';
            console.log('## SVR popupContactAccountPositionList ## changing history', newLink);
            history.push(newLink)
        }
    }, []);

    const contentCallback = useCallback(node => tellParentContentHeight(node, globalPersistentState.popupQueryObj), []);

    const onResize = (w, h) => {
        tellParentMessage({contentHeight: h}, globalPersistentState.popupQueryObj)
    };

    return (
        <div className={classes.root} ref={contentCallback} id={"positionListDiv"}>
            {accountPossibleDupes && (
                <div id={"positionListDivDiv"}>
                    <Typography variant="h6" component="h6" color="textPrimary" id={"positionListType"}>
                        Choose Existing Account
                    </Typography>
                    <List className={classes.accountList} id={"positionListList"}>
                        {accountPossibleDupes.map(accountPossibleDupe => {
                            return (
                                <Card key={accountPossibleDupe.accountId}>
                                    <CardActionArea
                                        onClick={(e) => {
                                            notify('currentContact', 'info', accountPossibleDupe.displayName + ' selected', null, null, globalPersistentState.popupQueryObj);
                                            const newLink = '/popup/contact/' + props.editId + '/positions/' + accountPossibleDupe.accountId + '/new';
                                            console.log('## SVR popupContactAccountPositionList ## changing history', newLink);
                                            history.push(newLink);
                                            setAccountPossibleDupes();
                                        }}>
                                        <CardContent>
                                            <Typography variant="body1" color="textPrimary">
                                                {accountPossibleDupe.displayName}
                                                {accountPossibleDupe.linkedinId ? ' (linkedin: ' + accountPossibleDupe.linkedinId + ')' : ''}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                Updated: <Moment
                                                calendar={CalendarStrings}>{accountPossibleDupe.updatedAt}</Moment>
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {accountPossibleDupe.description}
                                            </Typography>
                                            {accountPossibleDupe.tags &&
                                            <Typography variant="body2" color="textSecondary">
                                                Tags: {accountPossibleDupe.tags.map(tag => tag.tag).join(', ')}
                                            </Typography>}
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            )
                        })}
                        <Card>
                            <CardActionArea
                                onClick={(e) => {
                                    const newLink = '/popup/contact/' + props.editId + '/positions/new/new';
                                    console.log('## SVR popupContactAccountPositionList ## changing history', newLink);
                                    history.push(newLink);
                                    setAccountPossibleDupes();
                                }}>
                                <CardContent>
                                    <Typography variant="body1" color="textPrimary">
                                        Create New Contact - {globalPersistentState.popupQueryObj.selectionText}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </List>
                </div>
            )}
            {!accountPossibleDupes && contactAccountPositions && (
                <Switch>
                    <Route exact path={`${url}`}>
                        <PageBar
                            title={`Positions ${props.editObj ? 'of ' + props.editObj.displayName : ''}`}
                            handleSearch={handleSearch}
                            handleRefresh={handleRefresh}
                            handleAdd={() => {
                                console.log('## SVR popupContactAccountPositionList ## changing history', `${url}/new/new`);
                                history.push(`${url}/new/new`);
                            }}
                            handleEdit={() => {
                                console.log('## SVR popupContactAccountPositionList ## changing history', `${url}/${selectedObj.accountId}/${selectedObj.contactAccountPositionId}`);
                                history.push(`${url}/${selectedObj.accountId}/${selectedObj.contactAccountPositionId}`);
                            }}
                            editDisabled={selectedRows.length !== 1}
                            tagDisabled={selectedRows.length === 0}
                            handleDelete={handleDelete}
                            deleteDisabled={selectedRows.length !== 1}
                            exportDisabled={selectedRows.length === 0}
                            showLoading={getContactAccountPositionsLoading}
                        >
                        </PageBar>
                        <div className={classes.root}>
                            {contactAccountPositions && (
                                <SizeMe>
                                    {({size}) => {
                                        let height = size.height;
                                        if (!height) height = window.innerHeight;
                                        const fudge = 10;

                                        const tableOptions = {
                                            actionsColumnIndex: -1,
                                            header: true,
                                            // maxBodyHeight: height - (globalLayoutState.editTabBarHeight + fudge),
                                            padding: 'dense',
                                            paging: false,
                                            selection: true,
                                            selectionProps: r => ({
                                                name: r.account.accountName.replace(/\s+/g, '-').toLowerCase() === '___test' ? 'checkTest' : ''
                                            }),
                                            toolbar: false,
                                        };

                                        return (
                                            <MaterialTable
                                                columns={columns}
                                                data={contactAccountPositions}
                                                icons={tableIcons}
                                                options={tableOptions}
                                                onSearchChange={(str) => {
                                                    setSearchStr(str);
                                                }}
                                                onSelectionChange={(rows) => {
                                                    setSelectedRows(rows);
                                                    if (rows.length === 1) {
                                                        setSelectedObj(rows[0])
                                                    } else {
                                                        setSelectedObj({})
                                                    }
                                                }}
                                            />
                                        );
                                    }}
                                </SizeMe>
                            )}
                        </div>
                    </Route>
                    <Route path={`${url}/:accountId/:contactAccountPositionId`}>
                        {cloneElement(props.parent.routes.edit.component, {
                            ...props,
                            parentEditType: props.editType,
                            parentEditId: props.editId,
                            parentRefresh: () => {
                                getContactAccountPositionsRefetch()
                            },
                            editType: 'contactAccountPosition',
                            parent: props.parent.routes.edit
                        })}
                    </Route>
                </Switch>
            )}
            <ReactResizeDetector handleWidth handleHeight onResize={onResize}/>
        </div>
    )
};

export default PopupContactAccountPositionList
